export default __webpack_public_path__ + "static/media/bg-ecology.bfba11a2.jpg";